import React from 'react';

import { Search } from '@mui/icons-material';
import { Box, InputBase } from '@mui/material';

import { useDebouncedSearch } from '@/components/NewUI/hooks/useDebouncedSearch';

import { FONT_FAMILY, PRIMARY_GREEN, PRIMARY_TEAL } from './colors';

interface SearchInputProps {
  onSearch: (query: string) => void;
}

const SearchInput = ({ onSearch }: SearchInputProps) => {
  const { value, onChange } = useDebouncedSearch(onSearch);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: '#FFFFFF',
        borderRadius: '24px',
        padding: '16px 24px'
      }}
    >
      <Search sx={{ color: PRIMARY_GREEN, fontSize: '24px' }} />
      <InputBase
        onChange={onChange}
        placeholder="Search by name"
        value={value}
        sx={{
          flex: 1,
          fontFamily: FONT_FAMILY,
          fontSize: '14px',
          color: PRIMARY_TEAL,
          '& input::placeholder': { color: PRIMARY_TEAL, opacity: 1 }
        }}
      />
    </Box>
  );
};

export default SearchInput;
